<script setup>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Modal from "@/Components/Calendar/Modal.vue";
import SearchModal from "@/Components/Calendar/SlotSearchModal.vue";

import Navbar from "@/Components/Navbar.vue";
import Button from "@/Components/Button.vue";
import Select from "@/Components/Select.vue";
import Textarea from "@/Components/Textarea.vue";
import Label from "@/Components/Settings/Label.vue";
import Input from "@/Components/Settings/Input.vue";
import StatiSearch from "@/Components/Calendar/StatiSearch.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { ref, onMounted, watch } from "vue";

import PatientSearch from "@/Components/Calendar/PatientSearch.vue";
import VueTimepicker from "vue3-timepicker";

import { Inertia } from "@inertiajs/inertia";
import axios from "axios";
import debounce from "lodash/debounce";

const props = defineProps({
  errors: Object,
  practitioners: Object,
  rooms: Array,
  interval: Number,
  types: Array,
  date: String,
  time: String,
  behandler: String,
  appointment: Object,
  stati: Array,
  interval_values: Object,
  last_editor_info: String,
});

// console.log(props.appointment.patient, props.appointment.patient_custom);

const cancelModal = ref(false);
const showSearchModal = ref(false);
const modalData = ref({
  show: false,
  type: "",
  message: "",
});
const backUrl = ref("/");
const disabledRooms = ref([]);

//const patient = ref({
//    is_custom: props.appointment.patient_custom ? true : false,
//    patient_number: props.appointment.patient
//        ? props.appointment.patient.patient_number
//        : props.appointment.patient_custom.id,
//    patient_firstname: props.appointment.patient
//        ? props.appointment.patient.firstname
//        : props.appointment.patient_custom.firstname,
//    patient_lastname: props.appointment.patient
//        ? props.appointment.patient.lastname
//        : props.appointment.patient_custom.lastname,
//    birthday: props.appointment.patient
//        ? new Date(props.appointment.patient.birthday)
//              .toISOString()
//              .substr(0, 10)
//        : props.appointment.patient_custom.birthday,
//    email: props.appointment.patient
//        ? props.appointment.patient.email
//        : props.appointment.patient_custom.email,
//    tel: props.appointment.patient
//        ? props.appointment.patient.tel
//        : props.appointment.patient_custom.tel,
//});

const form = useForm({
  date: props.appointment.date,
  start: props.appointment.ap_start,
  duration: props.appointment.duration,
  practitioner_id: props.appointment.practitioner_id,
  room_id: props.appointment.room_id,
  type_id: props.appointment.type_id,

  is_custom: props.appointment.patient_custom ? true : false,
  patient_number: props.appointment.patient
    ? props.appointment.patient.patient_number
    : props.appointment.patient_custom.id,
  patient_firstname: props.appointment.patient
    ? props.appointment.patient.firstname
    : props.appointment.patient_custom.firstname,
  patient_lastname: props.appointment.patient
    ? props.appointment.patient.lastname
    : props.appointment.patient_custom.lastname,
  birthday: props.appointment.patient
    ? props.appointment.patient.birthday
      ? props.appointment.patient.birthday.substr(0, 10)
      : null
    : props.appointment.patient_custom.birthday
    ? props.appointment.patient_custom.birthday.substr(0, 10)
    : null,
  email: props.appointment.patient
    ? props.appointment.patient.email
    : props.appointment.patient_custom.email,
  tel: props.appointment.patient
    ? props.appointment.patient.tel
    : props.appointment.patient_custom.tel,

  description: props.appointment.description,
  equipment: props.appointment.equipment,
  status: props.appointment.status,
  ignore_warnings: false,
});

const patientResults = ref([]);

// onMounted(() => {
//   console.log("form:", form);
// });

function cancelAppointment() {
  Inertia.delete(`/termin-abbrechen/${props.appointment.id}`);
}

function updateAppointment(ignore_warnings = false) {
  form.ignore_warnings = ignore_warnings;
  form.put(`/appointments/${props.appointment.id}`, {
    onFinish: (data) => {
      form.ignore_warnings = false;
    },
    onError: (errors) => {
      if (errors.showModal) {
        modalData.value.show = true;
        modalData.value.type = errors.type;
        modalData.value.message = errors.message;
      }
    },
  });
}

function chooseSlot(slot) {
  //console.log("slot", slot);
  showSearchModal.value = false;
  form.date = slot.date;
  form.start = slot.startString;
}

function backClicked() {
  backUrl.value = window.history.back();
}

// check room
onMounted(() => {
  checkRoomOccupation();
});
watch(
  () => form.date,
  (cur, old) => {
    if (cur !== old) {
      checkRoomOccupation();
    }
  }
);
watch(
  () => form.start,
  (cur, old) => {
    if (cur !== old) {
      checkRoomOccupation();
    }
  }
);
watch(
  () => form.duration,
  (cur, old) => {
    if (cur !== old) {
      checkRoomOccupation();
    }
  }
);
function checkRoomOccupation() {
  let re = /^\d{2}:\d{2}$/; // 00:00
  if (form.date && form.start && re.test(form.start) && form.duration) {
    axios
      .get("/room/occupation", {
        params: {
          date: form.date,
          start: form.start,
          duration: form.duration,
          app_id: props.appointment.id,
        },
      })
      .then((resp) => {
        disabledRooms.value = resp.data.occupations;

        if (resp.data.occupations.includes(parseInt(form.room_id))) {
          form.reset("room_id");
        }
      })
      .catch((err) => {
        console.err("checkRoomOccupation error", err);
      });
  }
}
</script>

<template>
  <div
    id="theme-wrapper"
    style="background-image: url('/storage/img/auth_bg.jpg')"
    class="bg-cover bg-no-repeat flex h-screen bg-oteoBlue-600"
    :class="'theme-' + $page.props.theme ?? 'spitta'"
  >
    <Navbar class="navbar-sub w-full" />

    <SearchModal
      v-if="showSearchModal"
      :practitioners="props.practitioners"
      :rooms="props.rooms"
      :practitioner_id="form.practitioner_id"
      :room_id="form.room_id"
      :duration="form.duration"
      :start="form.date"
      :end="form.date"
      :interval="props.interval"
      @close="showSearchModal = false"
      @chooseSlot="chooseSlot"
    ></SearchModal>

    <Modal :show="cancelModal" @close="cancelModal = false">
      <template #title>Termin stornieren</template>
      <template #message>
        Wollen Sie diesen Termin wirklich stornieren?</template
      >
      <template #actions>
        <div class="flex gap-5 justify-center">
          <Button class="" @click="cancelModal = false">Abbrechen</Button>

          <Button class="" @click="cancelAppointment">Stornieren</Button>
        </div>
      </template>
    </Modal>

    <Modal :show="modalData.show" @close="modalData.show = false">
      <template #title> Fehler </template>
      <template #message>
        {{ modalData.message }}
      </template>
      <template #actions>
        <div class="" v-if="modalData.type === 'warning'">
          <div class="flex gap-5 justify-center mt-8">
            <Button
              class="mt-auto"
              @click="
                () => {
                  modalData.show = false;
                  showSearchModal = true;
                }
              "
              >Alternativer Termin</Button
            >

            <Button class="mt-auto" @click="updateAppointment(true)"
              >Termin übernehmen</Button
            >
          </div>
        </div>

        <div class="" v-if="modalData.type === 'error'">
          <div class="flex gap-5 justify-center mt-8">
            <Button
              class="mt-auto"
              @click="
                () => {
                  modalData.show = false;
                  showSearchModal = true;
                }
              "
              >Alternativer Termin</Button
            >

            <Button class="mt-auto" @click="modalData.show = false"
              >Abbrechen</Button
            >
          </div>
        </div>
      </template>
    </Modal>

    <div class="bg-white w-full max-w-8xl m-auto rounded-xl">
      <header
        class="bg-gray-100 flex justify-between items-center px-12 py-8 rounded-tl-xl rounded-tr-xl relative"
      >
        <div class="py-3">
          <h2
            class="text-3xl font-semibold mr-8 mb-1 break-words max-w-[600px] overflow-hidden text-ellipsis"
          >
            {{
              props.types.find((t) => t.id == props.appointment.type_id).name
            }}
          </h2>
          <div
            class="text-gray-500 opacity-80 break-words max-w-[600px] overflow-hidden text-ellipsis"
          >
            {{ props.appointment.last_editor_info }}
          </div>
          <div
            class="text-gray-500 opacity-80 break-words max-w-[600px] overflow-hidden text-ellipsis"
          >
            {{
              form.patient_firstname +
              " " +
              form.patient_lastname +
              (form.patient_number ? " (" + form.patient_number + ")" : "")
            }}
          </div>
          <!--<pre>{{ props }}</pre>-->
        </div>

        <div class="flex relative">
          <!-- <slot name="controls" /> -->
          <HeaderLink
            class="mr-3"
            type="close"
            @click="backClicked"
            :href="backUrl"
            >Abbrechen</HeaderLink
          >

          <HeaderButton class="mr-3" type="close" @click="cancelModal = true"
            >Stornieren</HeaderButton
          >

          <HeaderLink
            class="mr-3"
            :href="
              route('appointments.printview', {
                appointment: props.appointment,
              })
            "
            type="close"
            >Drucken</HeaderLink
          >

          <HeaderButton @click="updateAppointment()">Speichern</HeaderButton>
        </div>
      </header>
      <div class="flex p-12 relative">
        <div class="md:flex-1">
          <div class="flex">
            <div class="pr-16 pb-8 w-[35%]">
              <div class="opacity-60">
                <Label for="patient_number" value="Patient suchen" />
                <div class="flex gap-4 mt-1 relative">
                  <PatientSearch class="z-10" :disabled="true" />
                </div>
                <div
                  class="mt-2 text-red-600 text-sm"
                  v-if="errors.patient_number"
                >
                  {{ errors.patient_number }}
                </div>
              </div>

              <div :class="form.is_custom ? '' : 'opacity-60'">
                <div class="mt-8">
                  <Label for="patient_firstname" value="Vorname" />
                  <Input
                    :disabled="!form.is_custom"
                    id="patient_firstname"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.patient_firstname"
                    required
                    placeholder=""
                  />
                  <div
                    class="mt-2 text-red-600 text-sm"
                    v-if="errors.patient_firstname"
                  >
                    {{ errors.patient_firstname }}
                  </div>
                </div>

                <div class="mt-8">
                  <Label for="patient_lastname" value="Nachname" />
                  <Input
                    :disabled="!form.is_custom"
                    id="patient_lastname"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.patient_lastname"
                    required
                    placeholder=""
                  />
                  <div
                    class="mt-2 text-red-600 text-sm"
                    v-if="errors.patient_lastname"
                  >
                    {{ errors.patient_lastname }}
                  </div>
                </div>

                <div class="mt-8">
                  <Label for="birthday" value="Geburtstag" />
                  <Input
                    :disabled="!form.is_custom"
                    id="birthday"
                    type="date"
                    class="mt-1 block w-full"
                    v-model="form.birthday"
                    placeholder=""
                  />
                  <div class="mt-2 text-red-600 text-sm" v-if="errors.birthday">
                    {{ errors.birthday }}
                  </div>
                </div>

                <div class="mt-8 flex gap-4">
                  <div class="w-full">
                    <Label for="tel">
                      Handy
                      <span class="font-light">(für Terminservice)</span>
                    </Label>
                    <Input
                      :disabled="!form.is_custom"
                      id="tel"
                      type="tel"
                      class="mt-1 block w-full"
                      v-model="form.tel"
                      required
                      placeholder=""
                    />
                    <div class="mt-2 text-red-600 text-sm" v-if="errors.tel">
                      {{ errors.tel }}
                    </div>
                  </div>

                  <div class="w-full">
                    <Label for="email">
                      E-Mail
                      <span class="font-light">(für Terminservice)</span>
                    </Label>
                    <Input
                      :disabled="!form.is_custom"
                      id="email"
                      type="email"
                      class="mt-1 block w-full"
                      v-model="form.email"
                      required
                      placeholder=""
                    />
                    <div class="mt-2 text-red-600 text-sm" v-if="errors.email">
                      {{ errors.email }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-[35%] px-16 pb-8 border-x border-gray-200">
              <div class="">
                <Label for="date" value="Datum" />
                <Input
                  id="date"
                  type="date"
                  class="mt-1 block w-full"
                  v-model="form.date"
                  required
                  placeholder=""
                />
                <div class="mt-2 text-red-600 text-sm" v-if="errors.date">
                  {{ errors.date }}
                </div>
              </div>

              <div class="mt-8">
                <Label for="start" value="Uhrzeit" />

                <VueTimepicker
                  class="timepicker-input"
                  v-model="form.start"
                  :key="form.start"
                  :minute-interval="props.interval"
                  format="HH:mm"
                  close-on-complete
                  fixed-dropdown-button
                >
                  <template v-slot:dropdownButton>
                    <img :src="'/storage/icons/clock.png'" />
                  </template>
                </VueTimepicker>

                <!-- <Input
                  id="start"
                  type="time"
                  class="mt-1 block w-full"
                  v-model="form.start"
                  required
                  step="900"
                  min="10:00"
                  placeholder=""
                /> -->
                <div class="mt-2 text-red-600 text-sm" v-if="errors.start">
                  {{ errors.start }}
                </div>
              </div>

              <div class="mt-8">
                <Label for="type_id" value="Behandlungstyp" />
                <Select
                  id="type_id"
                  class="mt-1 block w-full"
                  v-model="form.type_id"
                  required
                >
                  <option disabled value="">Behandlungstyp auswählen</option>

                  <option v-for="type in types" :key="type.id" :value="type.id">
                    {{ type.name }}
                  </option>
                </Select>
                <div class="mt-2 text-red-600 text-sm" v-if="errors.type_id">
                  {{ errors.type_id }}
                </div>
              </div>

              <div class="mt-8">
                <Label for="duration" value="Dauer" />
                <Select
                  id="duration"
                  class="mt-1 block w-full"
                  v-model="form.duration"
                  required
                >
                  <option disabled value="">Dauer auswählen</option>

                  <!--<option v-for="n in 10" :key="n" :value="n">
                                        {{ `${n} Einheiten` }} -
                                        {{ n * interval }} Min.
                                    </option>-->
                  <option
                    v-for="(iv, n) in interval_values"
                    :key="n"
                    :value="n"
                  >
                    {{ `${n} Einheiten` }} - {{ iv }} Min.
                  </option>
                </Select>
                <div class="mt-2 text-red-600 text-sm" v-if="errors.duration">
                  {{ errors.duration }}
                </div>
              </div>

              <div class="mt-8">
                <Label for="room_id" value="Behandlungsraum" />
                <Select
                  id="room_id"
                  class="mt-1 block w-full"
                  v-model="form.room_id"
                  required
                >
                  <option disabled class="opacity-70" value="">
                    Behandlungsraum auswählen
                  </option>

                  <option
                    v-for="room in rooms"
                    :key="room.id"
                    :value="room.id"
                    :disabled="disabledRooms.includes(room.id)"
                  >
                    {{ room.name }}
                  </option>
                </Select>
                <div class="mt-2 text-red-600 text-sm" v-if="errors.room_id">
                  {{ errors.room_id }}
                </div>
              </div>
            </div>

            <div class="w-[30%] pl-16 pb-8">
              <div class="">
                <Label for="practitioner_id" value="Behandler/in" />
                <Select
                  id="practitioner_id"
                  class="mt-1 block w-full"
                  v-model="form.practitioner_id"
                  required
                >
                  <option disabled value="">Behandler/in auswählen</option>

                  <option
                    v-for="user in practitioners"
                    :key="user.id"
                    :value="user.id"
                  >
                    {{ user.fullname }}
                  </option>
                </Select>
                <div
                  class="mt-2 text-red-600 text-sm"
                  v-if="errors.practitioner_id"
                >
                  {{ errors.practitioner_id }}
                </div>
              </div>

              <div class="mt-8">
                <Label for="equipment" value="Werkzeuge/Materialen" />
                <Textarea
                  id="equipment"
                  class="mt-1 block w-full resize-none"
                  style="height: 5.6rem"
                  v-model="form.equipment"
                  required
                />
                <div class="mt-2 text-red-600 text-sm" v-if="errors.equipment">
                  {{ errors.equipment }}
                </div>
              </div>

              <div class="mt-8">
                <Label for="description" value="Anmerkungen" />
                <Textarea
                  id="description"
                  class="mt-1 block w-full resize-none"
                  style="height: 5.6rem"
                  v-model="form.description"
                  required
                />
                <div
                  class="mt-2 text-red-600 text-sm"
                  v-if="errors.description"
                >
                  {{ errors.description }}
                </div>
              </div>

              <div class="mt-8">
                <Label for="stati" value="Status" />

                <div class="flex gap-4 mt-1 relative">
                  <StatiSearch
                    :class="{
                      'opacity-60': form.customStati,
                    }"
                    :stati="stati"
                    :currentStatus="form.status"
                    v-model="form.status"
                    @selectStatus="form.status = $event"
                  />
                </div>

                <div class="mt-2 text-red-600 text-sm" v-if="errors.status">
                  {{ errors.status }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
